module.exports = __webpack_public_path__ + "assets/img/dingzhi@2x.571421eb.png";